import { createFileRoute } from "@tanstack/react-router";
import { useLanguage } from "@/i18n/LanguageProvider";
import { translations } from "@/i18n/translations";

type LegalSlug = "privacy" | "terms" | "child-safety" | "cookies";

function isLegalSlug(s: string): s is LegalSlug {
  return s === "privacy" || s === "terms" || s === "child-safety" || s === "cookies";
}

export const Route = createFileRoute("/legal/$slug")({
  head: ({ params }) => {
    const en = translations.en;
    const title = isLegalSlug(params.slug) ? en.legal[params.slug].title : en.legal.notFoundTitle;
    return { meta: [{ title: `${title} — Code Cubs Academy` }] };
  },
  component: LegalPage,
});

function LegalPage() {
  const { slug } = Route.useParams();
  const { t } = useLanguage();
  const p = isLegalSlug(slug) ? t.legal[slug] : { title: t.legal.notFoundTitle, body: "" };
  return (
    <div className="container mx-auto px-4 py-16 max-w-3xl">
      <h1 className="text-4xl font-extrabold mb-6">{p.title}</h1>
      <p className="text-muted-foreground leading-relaxed whitespace-pre-line">{p.body}</p>
    </div>
  );
}
